module.exports = __webpack_public_path__ + "9fa19396cf57252e7c202f511099fddd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/clowns-cabin-empty.png
// module id = 304
// module chunks = 0